import { usePersistedStore } from "@asurion-core/headless-chat-web";

import { useGuideStore } from "../store";
import { toSimplrTicketId } from "./simplrTicketId";

export function getRoomId(sessionId: string, isIdleSession = false) {
    const { errorStateSessionId } = useGuideStore.getState().getGuideSession(sessionId);
    const { externalTicketIdMetadataMap: roomIdsBySession, simplrChat } = usePersistedStore.getState();
    // The idle session starts without a ticket id, so the SDK keeps its room only in its config.
    // An error-state restart uses a ticket id again, so that room is in the map.
    if (isIdleSession && !errorStateSessionId) return simplrChat.config.roomId;
    return roomIdsBySession[toSimplrTicketId(errorStateSessionId || sessionId)]?.simplrChatRoomId;
}
